export const DELETE = 0;
export const CREATED = 1;
export const FOR_VERIFICATION = 2;
export const VERIFIED = 3;
export const POSTED = 4;
export const REJECTED = 5;
